import config from '../config';

// Gets a label string describing what environment is being used based on depot-service URL that is configured
export const getEnvironmentLabel = () => {
    switch (config.depotServiceURL) {
        case 'https://sagames-api.streamsix.com/depot':
            return 'prod';
        case 'https://sagames-stg-api.streamsix.com/depot':
            return 'stg';
        case 'https://sagames-test-api.streamsix.com/depot':
            return 'test';
        default:
            return 'dev';
    }
};
